export default [
    {
      text: "承装（修、试）电力设施许可证管理办法",
      url: "/pdf/marketInfo/承装（修、试）电力设施许可证管理办法.pdf",
    },
    {
      text: "国家发展改革委关于修改部分规章的决定",
      url: "/pdf/marketInfo/国家发展改革委关于修改部分规章的决定.pdf",
    },
  ];
  